<template>
    <div class="orders">
      <div class="orders-inner">

        <admin-sidebar></admin-sidebar>

        <div class="table">

          <div class="table-header">
            <div class="table-title">
              {{tableCount + ' ' + (tableCount === 1 ? 'order' : 'orders')}}
            </div>
            <div class="table-header-actions">
              <div v-if="this.$hasRole(['admin'])" class="add-user mobile-hide">
                <a @click.prevent="editOrder" :class="{'button': true, 'disabled': this.selectedRows.length === 0}">
                  edit
                </a>
              </div>
            </div>
          </div>

          <div class="table-list">

            <div class="table-list-inner">

              <el-table ref="multipleTable"
                        :data="tableData"
                        :fit="false"
                        v-el-table-infinite-scroll="handleInfiniteLoad"
                        :infinite-scroll-disabled="loading || scrollLoading"
                        style="width: 100%"
                        :height="height"
                        @selection-change="handleOrderSelectionChange"
                        @expand-change="loadItem"
                        row-key="id"
                        v-loading="loading"
              >

                <el-table-column type="expand" label="" width="30">
                  <template slot-scope="props">
                    <div v-loading="typeof props.row.assetsLoaded === 'undefined'" v-if="props.row.assetsLoaded === true" class="orders-item-expanded">
                      <template v-if="props.row.assetsLoaded === true">
                        <el-table :ref="'orderItems' + props.row.id"
                                  :data="props.row.orderItems"
                                  style="width: 100%"
                                  class="inner"
                                  :span-method="objectSpanMethod"
                                  @selection-change="handleSelectionChangeInit"
                                  :show-header="false"
                                  row-key="id">
                          <el-table-column width="30"></el-table-column>
                          <el-table-column label="test1" width="740">
                            <template slot-scope="itemProp">
                              <div class="orders-item-expanded-row">
                                <div class="orders-item-expanded-row-item">
                                  <div class="orders-item-expanded-image" @click="$router.push('/products/' + itemProp.row.asset_id)" :style="'background-image: url(' + getbase64EncodedImage(itemProp.row.thumbnail) + ')'" >
                                  </div>
                                  {{ typeof itemProp.row.filename !== 'undefined' ? itemProp.row.filename : 'removed from extensis' }}
                                </div>
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column>
                            <template slot-scope="itemProp">
                              <div>
                                {{itemProp.row.status}}
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column v-if="$hasRole(['admin'])" type="selection" width="180" header-align="right" align="right" ></el-table-column>
                        </el-table>

                      </template>
                    </div>
                    <template v-else>
                      <div class="table-list-inner-preload" :ref="'orderItemsLoader' + props.row.id" v-loading="true"></div>
                    </template>
                  </template>
                </el-table-column>

                <el-table-column prop="id" label="order" width="160" sortable></el-table-column>

                <el-table-column prop="date" label="date" width="160" sortable :sort-method="sortByDate">
                  <template slot-scope="scope">
                    {{ scope.row.created_at | formatDate('MM/DD/YYYY') }}
                  </template>
                </el-table-column>

                <el-table-column prop="user.first_name" label="first name" width="200" sortable></el-table-column>

                <el-table-column prop="user.last_name" label="last name" width="220" sortable></el-table-column>

                <el-table-column label="status" min-width="150" sortable>
                </el-table-column>

                <el-table-column v-if="this.$hasRole(['admin'])" type="selection" width="180" header-align="right" align="right" ></el-table-column>

              </el-table>

            </div>

          </div>

        </div>

        <div class="table-mobile" v-loading="loading">
          <div class="table-mobile-header">
            <div>{{tableData.length + ' ' + (tableData.length === 1 ? 'order' : 'orders')}}</div>
            <div v-if="this.$hasRole(['admin'])" class="add-user">
              <a @click.prevent="editOrder" :class="{'button': true, 'disabled': this.selectedRows.length === 0}">edit</a>
            </div>
          </div>
          <div class="table-mobile-items">
            <div class="table-mobile-items-item" v-for="item in tableData" :key="item.id">
              <div :class="{'el-table__expand-icon': true, 'el-table__expand-icon--expanded': mobileRowExpanded(item)}" @click="handleMobileExpandRow(item)"><i class="el-icon el-icon-arrow-right"></i></div>
              <div class="table-mobile-items-item-left">
                <div class="table-mobile-items-item-left-upper">
                  <span>Order {{item.id}}</span> <br/>
                  <template v-if="item.user">
                    {{item.user.first_name + ' ' + item.user.last_name}}
                  </template>
                </div>
                <div class="table-mobile-items-item-left-lower">
                  <span>status:</span> {{item.status}} <br/>
                  <span>date:</span> {{item.created_at | formatDate('MM/DD/YYYY')}} <br/>
                </div>
              </div>
              <div class="table-mobile-items-item-right table-list">
                <span :class="{'el-checkbox__input': true, 'is-checked': mobileSelectionChecked(item)}"  @click="handleMobileSelectionChange(item)"><span class="el-checkbox__inner"></span><input type="checkbox" aria-hidden="false" class="el-checkbox__original" value=""></span>
              </div>
              <div :class="{'table-mobile-items-item-expand': true, 'expanded': mobileRowExpanded(item)}">
                    <div v-if="typeof item.assetsLoaded !== 'undefined' && item.assetsLoaded === true" class="orders-item-expanded">
                      <template v-if="item.assetsLoaded === true">
                          <div class="orders-item-expanded-row table-list"  v-for="order in item.orderItems" :key="order.id">
                            <div class="table-mobile-items-item-left">
                              <div class="orders-item-expanded-row-item">
                                <div class="orders-item-expanded-image" @click="$router.push('/products/' + order.asset_id)" :style="'background-image: url(' + getbase64EncodedImage(order.thumbnail) + ')'" >
                                </div>
                                {{ typeof order.filename !== 'undefined' ? order.filename : 'removed from extensis' }}
                              </div>
                            </div>
                            <div class="table-mobile-items-item-right">

                            </div>
                            <div>
                              {{order.status}}
                            </div>
                            <span :class="{'el-checkbox__input': true, 'is-checked': mobileExpandedSelectionChecked(item, order)}"  @click="handleMobileExpandedSelectionChange(item, order)"><span class="el-checkbox__inner"></span><input type="checkbox" aria-hidden="false" class="el-checkbox__original" value=""></span>
                          </div>
                      </template>
                    </div>
                    <template v-else>
                      <div class="table-list-inner-preload" v-loading="true"></div>
                    </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { HTTP } from '@/services/api'
import { EventBus } from '@/services/eventbus'
import AdminSidebar from '@/views/Private/Components/AdminSidebar'

export default {
  name: 'Orders',
  components: { AdminSidebar },
  metaInfo () {
    return {
      title: 'Orders'
    }
  },
  data () {
    return {
      loading: false,
      scrollLoading: false,
      tableData: [],
      tableCount: 0,
      height: 300,
      pagination: {
        page: 1,
        perPage: process.env.VUE_APP_ORDERS_PAGINATION_SIZE || 40
      },
      hasMore: true,
      selectedRows: [],
      timeoutId: null
    }
  },
  created () {
    this.fixTableHeight()
    EventBus.$on('reload-orders', () => this.loadData())
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    EventBus.$off('reload-orders', true)
    window.removeEventListener('resize', this.handleResize)
  },
  mounted () {
    this.loadData()
    this.loadCount()
  },
  watch: {
    'pagination.page' () {
      if (!this.loading) {
        this.loadData()
      }
    }
  },
  methods: {
    fixTableHeight () {
      this.height = window.innerHeight - 200
    },
    handleInfiniteLoad () {
      this.scrollLoading = true
      this.pagination.page = this.pagination.page + 1
    },
    getbase64EncodedImage (item) {
      if (!item) {
        return ''
      }
      return 'data:image/jpeg;base64,' + item.replace(/(\r\n|\n|\r)/gm, '')
    },
    loadCount () {
      HTTP({
        method: 'GET',
        url: '/api/v1/orders/count',
        crossdomain: true
      })
        .then(response => {
          if (response.data.data) {
            this.tableCount = response.data.data
          }
        })
        .catch(() => {
        })
    },
    loadData () {
      if (!this.hasMore) {
        return
      }

      let scope = this

      if (this.tableData.length) {
        this.tableData.forEach(function (row) {
          if (scope.$refs.multipleTable) {
            scope.$refs.multipleTable.toggleRowExpansion(row, false)
          }
        })
      }

      this.loading = true
      HTTP({
        method: 'GET',
        url: '/api/v1/orders',
        params: this.pagination,
        crossdomain: true
      })
        .then(response => {
          if (response.data.data) {
            this.tableData = this.tableData.concat(response.data.data)
            if (response.data.data.length === 0) {
              this.hasMore = false
            }
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        }).finally(() => {
          setTimeout(() => {
            this.scrollLoading = false
          }, 500)
        })
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      return {
        rowspan: 1,
        colspan: 1
      }
    },
    debounce (method, delay) {
      clearTimeout(method._tId)
      method._tId = setTimeout(function () {
        method()
      }, delay)
    },
    handleResize () {
      this.debounce(this.fixTableHeight, 300)
    },
    sortByDate (a, b) {
      return new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
    },
    handleOrderSelectionChange (rows) {
      let scope = this

      this.tableData.forEach(function (item) {
        let key = 'orderItems' + item.id
        let index = rows.findIndex(function (row) {
          return row.id === item.id
        })
        if (index > -1) {
          if (scope.$refs[key]) {
            if (scope.$refs[key].selection.length === 0) {
              scope.$refs[key].toggleAllSelection()
            }
          }
        } else {
          if (scope.$refs[key]) {
            scope.$refs[key].clearSelection()
          }
        }
      })
    },
    mobileRowExpanded (item) {
      let key = 'orderItems' + item.id
      let loaderKey = 'orderItemsLoader' + item.id
      return (typeof this.$refs[key] !== 'undefined' || typeof this.$refs[loaderKey] !== 'undefined')
    },
    mobileExpandedSelectionChecked (item, order) {
      let key = 'orderItems' + item.id
      if (this.$refs[key] && this.$refs[key].selection) {
        return this.$refs[key].selection.find(function (single) {
          return single.id === order.id
        })
      }
      return false
    },
    mobileSelectionChecked (item) {
      if (this.$refs.multipleTable.selection) {
        return this.$refs.multipleTable.selection.find(function (single) {
          return single.id === item.id
        })
      }
      return false
    },
    handleMobileExpandRow (item) {
      this.$refs.multipleTable.toggleRowExpansion(item)
      let scope = this
      setTimeout(function () {
        scope.$forceUpdate()
      }, 200)
    },
    handleMobileSelectionChange (item) {
      this.$refs.multipleTable.toggleRowSelection(item)
    },
    handleMobileExpandedSelectionChange (item, order) {
      let key = 'orderItems' + item.id
      this.$refs[key].toggleRowSelection(order)
    },
    handleSelectionChange () {
      let scope = this
      scope.selectedRows = []
      this.tableData.forEach(function (item) {
        let key = 'orderItems' + item.id
        if (scope.$refs[key]) {
          if (scope.$refs[key].selection.length > 0) {
            scope.$refs[key].selection.forEach(function (selected) {
              scope.selectedRows.push(selected.id)
            })
          }
        }
      })
      EventBus.$emit('order-multiple-selection', scope.selectedRows)
    },
    handleSelectionChangeInit () {
      let scope = this
      if (this.timeoutId !== null) {
        clearTimeout(this.timeoutId)
      }
      this.timeoutId = setTimeout(_ => {
        scope.handleSelectionChange()
      }, 100)
    },
    async loadItem (row) {
      if (typeof row.assetsLoaded !== 'undefined') {
        return
      }

      let ids = row.orderItems.map(function (item) {
        return item.asset_id
      })

      await HTTP({
        method: 'GET',
        url: '/api/v1/assets/ids',
        params: {
          ids: ids
        },
        crossdomain: true
      })
        .then(response => {
          if (response.data.data) {
            let scope = this
            let assets = response.data.data
            row.orderItems.forEach(function (item) {
              let image = assets.assets.find(function (single) {
                return single.id === item.asset_id
              })

              if (image) {
                scope.$set(item, 'filename', image.attributes.Filename[0])
                scope.$set(item, 'thumbnail', image.attributes.Thumbnail[0])
              }
            })
            this.$set(row, 'assetsLoaded', true)
          }
        })
        .catch(() => {})
    },
    editOrder () {
      if (this.selectedRows.length === 0) {
        return
      }

      EventBus.$emit('open-modal', {
        type: 'order-update',
        data: {
          ids: this.selectedRows
        },
        header: true
      })
    }
  }
}
</script>
